import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  lead: {},
  type: '',
  open: true,
};

const leadSlice = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    leadValue: (state, action) => {
      return {...state, ...action.payload};
    },
    sideBarOpen: (state, action) => {
      return {...state, ...action.payload};
    },
    clearLeadValue: state => {
      state.lead = {};
      state.type = '';
    },
  },
});

export const {leadValue, clearLeadValue, sideBarOpen} = leadSlice.actions;

export default leadSlice.reducer;
